// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tooltip_wrapper__FU_4n"};